import React, { Component } from 'react';
import { markers } from "./Markers"
import { MapStyle } from './MapStyle';
import StethoscopeIcon from "../home-address.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Truncate from 'react-truncate';
import { faExpandArrowsAlt, faTimes  } from '@fortawesome/free-solid-svg-icons'

const _ = require("lodash");
const { compose, withProps, lifecycle } = require("recompose");
const { withScriptjs, withGoogleMap, GoogleMap, Marker } = require("react-google-maps");
const { InfoBox } = require("react-google-maps/lib/components/addons/InfoBox");
const { MarkerClusterer } = require("react-google-maps/lib/components/addons/MarkerClusterer");


class RenderMarker extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      expanded: false,
      truncated: false,
    }
  }

  createMarkup = (link) => {
    return {__html: link};
  }

  handleTruncate = (truncated) => {
       if (this.state.truncated !== truncated) {
           this.setState({
               truncated
           });
       }
   }

   toggleLines = (event) => {
       event.preventDefault();

       this.setState({
           expanded: !this.state.expanded
       });
   }

  onToggleOpen = () => {
    let isOpen = !this.state.isOpen

    // dialog open
    if (isOpen) {
      this.setState({
        isOpen: isOpen
      })

      if (this.props.placeSelected.id !== this.props.marker.id ) {
        this.props.selectTableByMarker(this.props.marker.id)
      }
    // dialog close
    } else {
      this.setState({
        isOpen: isOpen
      })
    }
  }

  render() {
    let { id, title, description, img, lat, lng} = this.props.marker
    const {
          expanded,
          truncated
      } = this.state;

        return (
          <Marker
            icon={StethoscopeIcon}
            position={{ lat: lat, lng: lng }}
            onClick={(ref) => this.onToggleOpen(this.props.marker)}
            key={id}
            animation={this.props.placeSelected.id === id ? this.state.animate : null}
            >
            {this.state.isOpen &&
              <InfoBox
                onCloseClick={this.onToggleOpen}

                options={{ closeBoxURL: `/close.gif`, enableEventPropagation: true, closeBoxMargin: "1.2em 1.2em 2px 2px", }}
                >
                <div style={{ backgroundColor: `white`, opacity: 1, padding: `0`,  width: `350px` }}>
                  <div style={{ fontSize: `16px`, fontColor: `#08233B` }}>
                  <div>
                    <strong className='infoTitle'>{ title }</strong>
                  </div>
                  { img &&
                    <div>
                    {<img src={img} alt={`${title} home `} className="imgHome"/>}
                      <br/>
                    </div>
                  }
                  { !img &&
                    <div>
                    {<img alt="no image available" src={"Final Maternity Home Photos/No Image.jpg"} className="imgNone"/>}
                      <br/>
                    </div>
                  }

                    { description &&
                      <div  className="infoDesc">
                      <Truncate
                       lines={!expanded && 6}
                       ellipsis={(
                           <span >... <a href='#' onClick={this.toggleLines}>Read More</a></span>
                       )}
                       onTruncate={this.handleTruncate}
                   >
                      <div dangerouslySetInnerHTML={this.createMarkup(description)} />
                   </Truncate>
                   {!truncated && expanded && (
                       <span> <a href='#' onClick={this.toggleLines}>Show Less</a></span>
                   )}

                      </div>
                    }

                  </div>
                </div>
              </InfoBox>
            }
          </Marker>
        )

  }
}

const google = window.google
const MapRenderer = compose(
  withProps({
    drawingMode: false,
    googleMapURL: "https://maps.googleapis.com/maps/api/js?key=AIzaSyDFUk4jt_1wvvcubdtFf4TGxDZVk44mHak&v=3.36&libraries=geometry,drawing,places",
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `100%` }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }),
  lifecycle({
    componentWillReceiveProps(newProps) {
      if (newProps.placeSelected !== this.props.placeSelected) {
        this.setState({
          placeSelected: newProps.placeSelected,
          zoom: 17
        })
      }
    },

  componentWillMount() {
    const refs = {}

    let props = this.props;
    let placeSelected;
    let zoom;

    if (_.isEmpty(props.placeSelected, true)) {
    placeSelected = props.center;
    zoom = 15
  } else {
    placeSelected = props.placeSelected;
    zoom =  1
  }

    this.setState({
      bounds: null,
      mapRef: null,
      zoom: zoom,
      center: props.center,
      markers: props.markers,
      placeSelected: placeSelected,
      selectTableByMarker: props.selectTableByMarker,

      onBoundsChanged: () => {
        if (refs && refs.map) {
          this.setState({
            markers: this.state.allMarkers,
            bounds: refs.map.getBounds(),
            center: refs.map.getCenter(),
          })
        }
      },
      onZoomChanged: () => {
        if (!_.isEmpty(props.markers) && !_.isEmpty(this.state)) {
          if (refs && refs.map) {
            let currentZoom = this.state.mapRef.getZoom()
            this.setState({ zoom: currentZoom })
          }
        }
      },



      zoomToMarkers: map => {
        if (!_.isEmpty(props.markers)) {
          // let map = this.state.mapRef
          const bounds = new window.google.maps.LatLngBounds();

          props.markers.map((child, id) => {
              bounds.extend(new window.google.maps.LatLng(child.lat, child.lng));

          })

          if (map) {
            map.fitBounds(bounds)
          }
          this.setState({mapRef: map})
        }
      },
      zoomToMarkersButton: () => {
        if (!_.isEmpty(props.markers)) {
          let map = this.state.mapRef
          const bounds = new window.google.maps.LatLngBounds();

          props.markers.map((child, id) => {
              bounds.extend(new window.google.maps.LatLng(child.lat, child.lng));

          })

          if (map) {
            map.fitBounds(bounds)
          }
          this.setState({mapRef: map})
        }
      },
      toggleMapview: () => {
        this.props.toggleMapview()
      },
      getGoogleClusterInlineSvg: (color) => {
              var encoded = window.btoa(`<svg width="100%" height="100%" viewBox="0 0 50 50" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"><circle cx="25.277" cy="25.233" r="24.216" style="fill:#398c5b;fill-opacity:0.36;"/><circle cx="25.339" cy="25.171" r="18.148" style="fill:#398c5b;"/><g><g><path d="M15.657,20.114l-5.719,3.952l-1.048,2.279l2.224,6.771l8.581,0.243l2.755,-6.702l-6.793,-6.543Z" style="fill:#fff;"/><path d="M12.171,26.762l0,4.976l1.754,0l0,-3.167c0,-0.249 0.196,-0.452 0.439,-0.452l2.63,0c0.242,0 0.439,0.203 0.439,0.452l0,3.167l1.754,0l0,-4.976c0,-0.25 0.196,-0.453 0.438,-0.453l0.465,0l-4.411,-3.5l-4.411,3.5l0.465,0c0.242,0 0.438,0.203 0.438,0.453Z" style="fill:#398c5b;fill-rule:nonzero;"/><rect x="14.802" y="29.024" width="1.754" height="2.714" style="fill:#398c5b;fill-rule:nonzero;"/><path d="M14.367,36.52c1.65,-2.126 10.081,-3.936 10.081,-8.401c0,-4.997 -3.926,-9.048 -8.769,-9.048c-4.843,0 -7.068,3.743 -7.068,8.74c0,4.466 4.106,6.584 5.756,8.709Zm-4.655,-10.115l5.7,-4.524c0.157,-0.125 0.377,-0.125 0.534,0l5.7,4.524c0.148,0.119 0.206,0.32 0.146,0.503c-0.06,0.182 -0.226,0.305 -0.413,0.306l-1.316,0l0,4.977c0,0.249 -0.196,0.452 -0.438,0.452l-7.892,0c-0.242,0 -0.439,-0.203 -0.439,-0.452l0,-4.977l-1.315,0c-0.188,0 -0.354,-0.123 -0.415,-0.306c-0.06,-0.184 -0.001,-0.386 0.148,-0.504l0,0.001Z" style="fill:#398c5b;fill-rule:nonzero;"/></g><g><path d="M35.235,21.036l-6.931,5.557l-0.085,0.645l1.72,6.556l8.563,-0.364l2.755,-6.702l-6.022,-5.692Z" style="fill:#fff;"/><path d="M30.978,26.833l0,4.976l1.754,0l0,-3.166c0,-0.25 0.196,-0.453 0.438,-0.453l2.631,0c0.242,0 0.439,0.203 0.439,0.453l0,3.166l1.753,0l0,-4.976c0,-0.25 0.197,-0.452 0.439,-0.452l0.465,0l-4.411,-3.501l-4.411,3.501l0.465,0c0.242,0 0.438,0.202 0.438,0.452Z" style="fill:#398c5b;fill-rule:nonzero;"/><rect x="33.609" y="29.095" width="1.754" height="2.714" style="fill:#398c5b;fill-rule:nonzero;"/><path d="M33.174,36.591c0.935,-1.204 3.201,-0.749 5.722,-2.291c1.929,-1.18 2.41,-4.998 2.41,-6.933c0,-4.997 -10.151,-8.704 -5.771,-6.637c0.02,0.009 -7.273,5.741 -7.291,5.952c-0.329,3.901 3.28,7.784 4.93,9.909Zm-4.656,-10.115l5.7,-4.524c0.158,-0.125 0.378,-0.125 0.535,0l5.7,4.524c0.148,0.119 0.206,0.321 0.146,0.503c-0.061,0.183 -0.226,0.306 -0.413,0.306l-1.316,0l0,4.977c0,0.25 -0.196,0.452 -0.438,0.452l-7.892,0c-0.243,0 -0.439,-0.202 -0.439,-0.452l0,-4.977l-1.315,0c-0.188,0 -0.355,-0.123 -0.415,-0.306c-0.061,-0.184 -0.001,-0.386 0.147,-0.504l0,0.001Z" style="fill:#398c5b;fill-rule:nonzero;"/></g><g><path d="M25.589,27.302l-7.6,6.049l-1.562,1.821l3.85,5.398l10.847,0.04l2.025,-7.218c0.047,0.036 -7.593,-6.069 -7.56,-6.09Z" style="fill:#fff;"/><path d="M21.368,33.432l0,5.978l2.102,0l0,-3.804c0,-0.3 0.235,-0.543 0.525,-0.543l3.152,0c0.29,0 0.525,0.243 0.525,0.543l0,3.804l2.102,0l0,-5.978c0,-0.3 0.235,-0.543 0.525,-0.543l0.557,0l-5.285,-4.205l-5.285,4.205l0.557,0c0.29,0 0.525,0.243 0.525,0.543Z" style="fill:#398c5b;fill-rule:nonzero;"/><rect x="24.52" y="36.149" width="2.101" height="3.261" style="fill:#398c5b;fill-rule:nonzero;"/><path d="M24.834,42.031c6.487,-0.332 10.533,-1.536 10.338,-8.062c-0.017,-0.596 -4.364,-3.741 -2.451,-0.966c0.004,0.007 -6.693,-5.359 -6.83,-5.434c-0.43,-0.238 -0.931,0.196 -0.854,0.169c0.182,-0.061 -4.071,3.266 -4.086,3.268c-1.156,0.172 2.365,-4.269 3.442,-4.545c0.025,-0.007 -8.534,6.988 -9.719,8.205c-3.742,3.844 6.481,6.659 10.16,7.365Zm-6.413,-9.028l0,-0.001l5.162,-4.222l1.704,-1.612c0.189,-0.15 0.612,-0.693 0.8,-0.543l7.28,5.956l-0.646,0.422c0.176,0.143 0.246,0.385 0.174,0.605c-0.072,0.219 -0.271,0.367 -0.495,0.368l-1.576,0l0,5.978c0,0.3 -0.235,0.543 -0.525,0.543l-9.456,0c-0.29,0 -0.525,-0.243 -0.525,-0.543l0,-5.978l-1.576,0c-0.225,0 -0.425,-0.148 -0.497,-0.369c-0.073,-0.22 -0.002,-0.463 0.176,-0.605l0,0.001Z" style="fill:#398c5b;fill-rule:nonzero;"/><path d="M28.33,27.616l-0.078,1.818l4.305,3.485l0.82,-0.307l1.291,1.164l0.314,-0.582l0.325,0.491l-6.977,-6.069Z" style="fill:#398c5b;"/></g></g></svg>
`);
              return ('data:image/svg+xml;base64,' + encoded);
            }


      // zoomToMarkers: map => {
      //   this.setState({mapRef: map})
      // },
    })
  },
}),
  withScriptjs,
  withGoogleMap
)(props =>
  <GoogleMap
   defaultZoom={8}
   defaultCenter={{ lat: -34.397, lng: 150.644 }}
   ref={ props.zoomToMarkers}
     defaultOptions={{ styles: MapStyle }}
    defaultCenter={props.center}
    defaultZoom={props.zoom}
    center={props.placeSelected}
    zoom={props.zoom}
    onBoundsChanged={props.onBoundsChanged}
    onZoomChanged={props.onZoomChanged}
 >
   <a id="close-map" onClick={props.toggleMapview}><FontAwesomeIcon icon={faTimes} /></a>
   <a id="zoom-extends-btn" onClick={props.zoomToMarkersButton}><FontAwesomeIcon icon={faExpandArrowsAlt} /> Zoom All</a>
 <MarkerClusterer
    averageCenter
    enableRetinaIcons
    gridSize={40}
    zoomOnClick={true}
    minimumClusterSize={4}
    maxZoom={19}
    defaultMaxZoom={20}
    styles={[
      {
       width: 80,
       height: 80,
       url: props.getGoogleClusterInlineSvg('#0071bc'),
       textColor: 'white',
       textSize:20,
       anchorText: [-11, 0]
   }
    ]}
  >
 { props.markers.map((marker, index) => {
    return (
      <RenderMarker
        key={index}
        marker={marker}
        placeSelected={props.placeSelected}
        selectTableByMarker={props.selectTableByMarker}
      />
    )
  })}
   </MarkerClusterer>
 </GoogleMap>
);

class RenderMap extends Component {
  static defaultProps = {
    center: {
      lat: 46.7879926,
      lng: -67.6970126
    },
    zoom: 11,
  }

  constructor(props) {
    super(props);

    let key = "AIzaSyCqxrL-hWchWCqF5ZITCDQn-lRrxJZsUTo"
  }

  render() {
    let { center, zoom, toggleMapview } = this.props
    return (
      <div id="googleMap" className="animated fadeInDownBig delay-0.5s" style={{ height: this.props.height, width: this.props.width }}>
        <MapRenderer
          toggleMapview={toggleMapview}
          markers={markers}
          placeSelected={this.props.placeSelected}
          selectTableByMarker={this.props.selectTableByMarker}
          center={center}
          />
          <div className="bottomInfo">
          The information for this map was researched and compiled by Valerie Andrews, 2009.
          </div>
      </div>
    )
  }
}

export default RenderMap;
